import { ServiceBase } from "services/base-service";
import type { FileSyncStatus } from "features/dataSync/types";

class DataSyncService extends ServiceBase {
  constructor() {
    super();

    this.baseUrl = `${this.baseUrl}/File`;
  }

  async getFileStatus(abortController?: AbortController): Promise<FileSyncStatus> {
    const url = "/get-file-generation-status";
    const response = await this.sendGet(url, abortController);

    return response;
  }

  async runGenerateTranslations(abortController?: AbortController): Promise<string> {
    const url = "/generate-translations-zip";
    const response = await this.sendPost(url, null, abortController);

    return response;
  }

  async uploadFile(file: File, abortController?: AbortController): Promise<void> {
    const url = "/upload-translations-zip";
    const formData = new FormData();
    formData.append("file", file);

    await this.sendPost(url, formData, abortController);
  }

  async uploadNativeLangFile(file: File, abortController?: AbortController): Promise<void> {
    const url = "/upload-native-language-zip";
    const formData = new FormData();
    formData.append("file", file);

    await this.sendPost(url, formData, abortController);
  }
}

const dataSyncService = new DataSyncService();

export { dataSyncService };
